import { __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { context } from './utils';
import s from './select.module.css';
var Group = function Group(_ref) {
  var label = _ref.label,
    children = _ref.children;
  return React.createElement("div", {
    className: classNames(s.group)
  }, label && label.length ? React.createElement("div", {
    className: classNames(s.section)
  }, label) : null, React.createElement(React.Fragment, null, children));
};
var NativeGroup = function NativeGroup(_ref2) {
  var label = _ref2.label,
    children = _ref2.children;
  return React.createElement("optgroup", {
    label: label
  }, children);
};
var SelectGroup = function SelectGroup(_a) {
  var props = __rest(_a, []);
  var _useContext = useContext(context),
    native = _useContext.native;
  return native ? React.createElement(NativeGroup, Object.assign({}, props)) : React.createElement(Group, Object.assign({}, props));
};
export default SelectGroup;